export default "__VITE_PUBLIC_ASSET__70643792__"